import { invalidateItemQueries } from '@/shared/api/invalidate-item-queries';
import { trpc } from '@/shared/api/trpc';

export const useUpdateItem = () => {
  const utils = trpc.useUtils();
  return trpc.operations.updateItem.useMutation({
    onSettled: () => invalidateItemQueries(utils),
  });
};
